<script setup>
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import { computed } from "@vue/reactivity";

const props = defineProps({
  status: String,
});

const form = useForm();
const route = window.route;

const submit = () => {
  form.post(route("verification.send"));
};

const verificationLinkSent = computed(
  () => props.status === "verification-link-sent"
);
</script>
<template>
  <Head title="Email Verification" />
  <div class="flex justify-center pt-12">
    <div class="border border-blue-600 border-opacity-25 p-12 rounded shadow">
      <div class="py-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-12 h-12 mx-auto text-blue-600"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
          />
        </svg>
      </div>
      <div class="mb-4 text-sm text-gray-600 max-w-md text-center">
        Thanks for signing up! Before getting started, could you verify your
        email address by clicking on the link we just emailed to you? If you
        didn't receive the email, we will gladly send you another.
      </div>
      <div
        class="mb-4 font-medium text-sm text-green-600 max-w-md text-center"
        v-if="verificationLinkSent"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-7 h-7 text-green-500 mx-auto"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p>
          A new verification link has been sent to the email address you
          provided during registration.
        </p>
      </div>
      <form @submit.prevent="submit" class="py-2">
        <div class="mt-4 flex items-center justify-between">
          <button
            class="
              bg-blue-600
              text-white
              px-6
              py-2
              rounded
              text-xs tracking-widest
              uppercase
            "
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Resend Verification Email
          </button>

          <Link
            :href="route('logout')"
            method="post"
            as="button"
            class="
              border border-blue-600 text-blue-600
              shadow-sm
              p-2
              rounded
              text-xs uppercase
              hover:text-gray-900
              tracking-wide
            "
            >Log Out</Link
          >
        </div>
      </form>
    </div>
  </div>
</template>